module.exports = __webpack_public_path__ + "static/media/categories.cedc92a4.jpg";